export const lang = {
  schedule:"Plan",
  debtor:"Admission modality",
  taxed_amount:"Amount",
  received_amount:"Received amount"
};
